import { compose, withProps, withHandlers, setPropTypes } from "recompose";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { createHocBase } from "app/utils";
import hash from "object-hash";
import PropTypes from "prop-types";
import * as actions from "./actions";
import { withRouter } from "react-router";

// NOTE this assumes the topic has been loaded
const selectFeedbackState = (state, props) => {
  const params = props.locationParams;
  const topic = state.topics.topicsById[params.topicId];
  return {
    locationFeedback: state.feedback[params.id],
    locationObjectTitle: props.locationObject.title,
    ruleName: topic.config.ruleName
  };
};

const createFeedbackActions = dispatch => bindActionCreators(actions, dispatch);

export const connectFeedbackState = connect(selectFeedbackState);

export const connectFeedbackActions = connect(
  null,
  createFeedbackActions
);

const fetchConditional = props => {
  const {
    fetchFeedback,
    locationParams,
    locationFeedback,
    ruleName,
    locationObjectTitle
  } = props;
  if (locationParams && !locationFeedback) {
    fetchFeedback({ ...locationParams, ruleName, locationObjectTitle });
  }
};

export const fetchFeedback = Component =>
  class extends createHocBase(Component) {
    componentDidMount(prevProps) {
      fetchConditional(this.props);
    }
    componentDidUpdate(prevProps) {
      const params = this.props.locationParams;
      const prevParams = prevProps.locationParams;
      if (prevParams.id === params.id) return;
      fetchConditional(this.props);
    }
  };

const createLocationParams = props => {
  const {
    locationObject,
    match: {
      params: { topicId }
    }
  } = props;
  const id = hash(locationObject);
  const feature = {
    type: "Feature",
    properties: locationObject.inputs,
    geometry: locationObject.location
  };
  const locationParams = { id, feature, topicId };
  return {
    locationParams
  };
};

const reloadFeedback = props => () => {
  const { fetchFeedback, locationParams } = props;
  fetchFeedback(locationParams);
};

export const withLocationFeedback = compose(
  setPropTypes({
    locationObject: PropTypes.object.isRequired
  }),
  withRouter,
  withProps(createLocationParams),
  connectFeedbackState,
  connectFeedbackActions,
  withHandlers({
    reloadFeedback
  }),
  fetchFeedback
);



// WEBPACK FOOTER //
// ./src/app/feedback/hocs.js